import { FacetLabels } from '../models/facet-labels.model';

export function getFacetLabel(facetKey: string, value: string, labels: FacetLabels): string {
  switch (facetKey) {
    case 'domainId':
      return labels.domains[value] ?? value;
    case 'categoryId':
      return labels.categories[value] ?? value;
    case 'typeId':
      return labels.types[value] ?? value;
    case 'availabilityTypeId':
      return labels.availabilityTypes[value] ?? value;
    case 'countyId':
      return labels.counties[value] ?? value;
    case 'cityId':
      return labels.cities[value] ?? value;
    case 'annexes':
      return labels.annexes[value] ?? value;
    case 'areas':
      return labels.areas[value] ?? value;
    case 'targetAudience':
      return labels.targetAudiences[value] ?? value;
    default:
      return value;
  }
}
